import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ServicesHero from "./components/ServicesHero";
import ServiceDetail from "./components/ServiceDetail";
import CTASection from "@/pages/home/components/CTASection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const servicesJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/services#webpage`,
      "url": `${SITE_URL}/services`,
      "name": "Web Design & Digital Marketing Services | GK Vertex Consulting",
      "description": "Explore GK Vertex Consulting's full range of services: custom web design, SEO optimization, digital marketing, and lead generation strategies built to grow your business.",
      "inLanguage": "en-US",
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "dateModified": "2026-04-05",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
          { "@type": "ListItem", "position": 2, "name": "Services", "item": `${SITE_URL}/services` }
        ]
      }
    },
    {
      "@type": "ItemList",
      "name": "GK Vertex Consulting Services",
      "description": "Full range of web design and digital marketing services offered by GK Vertex Consulting.",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Service",
            "name": "Custom Web Design",
            "url": `${SITE_URL}/services`,
            "provider": { "@type": "Organization", "name": "GK Vertex Consulting", "url": SITE_URL },
            "description": "100% custom-built websites designed to convert visitors into paying clients. No templates, no shortcuts.",
            "areaServed": "Worldwide"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Service",
            "name": "SEO Optimization",
            "url": `${SITE_URL}/services`,
            "provider": { "@type": "Organization", "name": "GK Vertex Consulting", "url": SITE_URL },
            "description": "Search engine optimization strategies that drive organic traffic, improve rankings, and generate qualified leads.",
            "areaServed": "Worldwide"
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Service",
            "name": "Digital Marketing",
            "url": `${SITE_URL}/services`,
            "provider": { "@type": "Organization", "name": "GK Vertex Consulting", "url": SITE_URL },
            "description": "Comprehensive digital marketing campaigns that generate real leads and deliver measurable growth for your business.",
            "areaServed": "Worldwide"
          }
        },
        {
          "@type": "ListItem",
          "position": 4,
          "item": {
            "@type": "Service",
            "name": "Lead Generation",
            "url": `${SITE_URL}/services`,
            "provider": { "@type": "Organization", "name": "GK Vertex Consulting", "url": SITE_URL },
            "description": "Targeted lead generation strategies that connect you with your ideal customers and grow your revenue.",
            "areaServed": "Worldwide"
          }
        }
      ]
    },
    {
      "@type": "Service",
      "provider": {
        "@type": "Organization",
        "name": "GK Vertex Consulting",
        "url": SITE_URL,
        "email": "gkvertexconsulting@gmail.com"
      },
      "serviceType": "Web Design & Digital Marketing",
      "name": "Custom Web Design & Digital Marketing",
      "description": "GK Vertex Consulting offers custom web design, SEO, digital marketing, and lead generation services tailored to grow your business online.",
      "areaServed": "Worldwide",
      "url": `${SITE_URL}/services`,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Web Design & Digital Marketing Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom Web Design" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SEO Optimization" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Digital Marketing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Lead Generation" } }
        ]
      }
    }
  ]
};

export default function ServicesPage() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "services-jsonld";
    script.text = JSON.stringify(servicesJsonLd);
    document.head.appendChild(script);
    document.title = "Web Design & Digital Marketing Services | GK Vertex Consulting";
    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", "Explore GK Vertex Consulting's full range of services: custom web design, SEO optimization, digital marketing, and lead generation strategies built to grow your business.");
    return () => {
      const el = document.getElementById("services-jsonld");
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050810]">
      <Navbar />
      <main>
        <ServicesHero />
        <ServiceDetail />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
